document.addEventListener('DOMContentLoaded', () => {
    console.log("Shared file");
});

